<template>
  <div>
    <lida-table
      :propscolumns="columns(false)"
      :data="totalItems"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">全部</p>
      </template>
    </lida-table>
    <lida-table
      v-for="(it, key) in totalData"
      :key="key"
      :propscolumns="columns(true, key)"
      :data="it"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      class="my-2"
      :LeaveSpace="false"
      :page="false"
      :ref="[`table${key}`]"
      :mytlpa="mytlpa"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">{{getGamename(key)}}</p>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import switchHie from "../mixins/switchHie.js"
import reportCount from '@/mixins/report-count.js'
export default {
  name: 'reporta2',
  mixins: [reportCount, switchHie],
  data () {
    return {
      totalData: [],
      notSunArray: ['hie', 'iscash1', 'mid', 'memcou', 'l3username', 'l3name', 'l2p'],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
  },
  created () {
    this.getmytlpa()
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.loading = true
      try {
        const data = {
          ...this.query,
          repnum: 2,
          mid: this.query.mid,
          stid: this.query.stidlist || this.query.stid
        }
        const res = await this.$axios.generalLedger.linkreporta2_9(data)
        if ('status' in res && res.status === 0) return
        this.totalData = { ...this.itemsDefault(), ...res }
        this.sunTotal({ name: 'l3name', name2: 'l3username' })
        this.TableScrollTop()
        this.itemsSort()
      } catch (error) {
        console.error(error);
        this.checkUrl(error)
      } finally {
        this.loading = false
      }
    },
    columns (status = true, gameid) {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 50
        },
        l3name: {
          title: '大股東',
          align: 'center',
          key: 'l3name',
          totaltext: '总计',
          notetext: '本占比总计',
          minWidth: 60,
          render: (h, params) => {
            if (this.checkFooterText(params.row.l3name)) {
              return params.row.l3name == '本占比总计'
                ? h('span', `${params.row.l3name} (${this.mytlpa}%)`)
                : h('span', params.row.l3name)
            } else {
              return h('a', {
                on: {
                  click: () => this.$router.push({
                    name: `general-ledger-reporta${params.row.hie}`,
                    query: { ...this.query, mid: params.row.mid, gameid, lastLevel: 2, },
                    params: { scrollGameid: gameid }
                  })
                }
              },
                [
                  h('span', { class: { pc3: true, 'word-break': true } }, params.row.l3name),
                  h('span', { class: { pc2: true, 'word-break': true } }, ` ${params.row.l3username}`)
                ])
            }

          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          total: true,
          minWidth: 2,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        memcou: {
          title: '会员数',
          align: 'center',
          key: 'memcou',
          total: true,
          width: this.lidaTableCheck ? 40 : 100,
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          note: true,
          minWidth: 20,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 10,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        hie: {
          title: '会员奖金',
          align: 'center',
          key: 'hie',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => {
            const value = params.row.mpaysum - params.row.payds
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          note: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
        l3pays: {
          title: '大股东占成',
          align: 'center',
          key: 'l3pays',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l3pays')
        },
        l3upps: {
          title: '大股东占成上缴',
          align: 'center',
          key: 'l3upps',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l3upps')
        },
        l3upt: {
          title: '大股东上缴',
          align: 'center',
          key: 'l3upt',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l3upt')
        },
        l3bkpds: {
          title: '大股东退佣',
          align: 'center',
          key: 'l3bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l3bkpds')
        },
        odddiffval2: {
          title: '大股东差价数',
          align: 'center',
          key: 'odddiffval2',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'odddiffval2')
        },
        l3paysum: {
          title: '大股东盈亏',
          align: 'center',
          key: 'l3paysum',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l3paysum')
        },
        l2p: {
          title: '分公司占成(%)',
          align: 'center',
          key: 'l2p',
          width: this.lidaTableCheck ? 40 : 100,
          render: (h, params) => {
            if (this.checkFooterText(params.row.l3name)) return
            return !this.checkFooterText(params.row.l2name) ? h('p', `${params.row.l2p > 0 ? params.row.l2p : 0}%`) : null
          },
        },
        l2pays: {
          title: '分公司占成',
          align: 'center',
          key: 'l2pays',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2pays')
        },
        l2pdsd: {
          title: '分公司佣金差',
          align: 'center',
          key: 'l2pdsd',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2pdsd')
        },
        odddiffval1: {
          title: '分公司差价数',
          align: 'center',
          key: 'odddiffval1',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'odddiffval1')
        },
        l2paysum: {
          title: '分公司盈亏',
          align: 'center',
          key: 'l2paysum',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l2paysum')
        },
        l2upps: {
          title: '分公司占成上缴',
          align: 'center',
          key: 'l2upps',
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upps')
        },
        l2upt: {
          title: '分公司上缴',
          align: 'center',
          key: 'l2upt',
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upt')
        },
        l2bkpds: {
          title: '分公司退佣',
          align: 'center',
          key: 'l2bkpds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2bkpds')
        },
        l2paysumt: {
          title: '分公司占成盈亏',
          align: 'center',
          key: 'l2paysumt',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'l2paysumt')
        },
        l2pds: {
          title: '分公司赚佣',
          align: 'center',
          key: 'l2pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2pds')
        },
        mid: {
          title: '公司占成',
          align: 'center',
          key: 'l2upps',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upps')
        },
        l1pds: {
          title: '公司赚佣',
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          note: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
      }
      if (!status) delete object.memcou
      return object
    }
  }
}
</script>